import React from "react";

export default function AdsCarousel({ items = [], intervalMs = 6000, className = "" }) {
    const [idx, setIdx] = React.useState(0);
    const count = items.length;

    React.useEffect(() => {
        if (count <= 1) return;
        const t = setInterval(() => setIdx((i) => (i + 1) % count), intervalMs);
        return () => clearInterval(t);
    }, [count, intervalMs]);

    if (!count) return null;

    return (
        <div className={`rounded-xl bg-white p-4 relative overflow-hidden ${className}`}>
            <div>
                <div className="text-[14px] mb-2 font-[450] text-[#5E01D6]">What’s New</div>
            </div>
            {/* dots */}
            {count > 1 && (
                <div className="absolute right-6 top-6 flex items-center gap-2">
                    {items.map((_, i) => (
                        <button
                            key={i}
                            onClick={() => setIdx(i)}
                            className={`
                                h-2 rounded-full transition-all duration-300 
                                ${i === idx ? "w-6 bg-[#6F00FF]" : "w-2 bg-[#E8E9F4]"}
                            `}
                            aria-label={`Go to slide ${i + 1}`}
                        />
                    ))}
                </div>
            )}

            <div className="w-full">{items[idx]}</div>
        </div>
    );
}
